import React from "react";
import PropTypes from "prop-types";

export function SelfHostedServerActionButton(props) {

  return (
    <button onClick={props.onClick} className={`account-shs-action-button${props.type ? ` account-shs-action-button--${props.type}` : ""}`} type="button">
      <span className={props.glyph}/>
      <span>{props.text}</span>
    </button>
  );
}

SelfHostedServerActionButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  glyph: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  type: PropTypes.string
}